import React, { useEffect, useState } from "react";
import { PodcastRequestCard } from "../../components/PodcastRequestCard";
import { Link } from "react-router-dom";
import { Users, TrendingUp, MessageCircle, Store, BellRing } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

const LINKS = [
  { to: "/dashboard/contacts", l: "Client book", d: "Leads, bookings and bulk uploads", icon: Users },
  { to: "/dashboard/reports", l: "Reports", d: "Leads, revenue and profile views", icon: TrendingUp },
  { to: "/messages", l: "Inbox", d: "Chat with couples in real time", icon: MessageCircle },
  { to: "/dashboard/vendor-profile", l: "Public profile", d: "How couples find you", icon: Store },
];

export default function ProHome() {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [cold, setCold] = useState([]);
  useEffect(() => {
    api.get("/contacts?kind=client").then((r) => setClients(r.data)).catch(() => {});
    api.get("/contacts/follow-ups").then((r) => setCold(r.data)).catch(() => {});
  }, []);
  const count = (s) => clients.filter((c) => (c.status || "lead") === s).length;
  const stats = [["Open leads", count("lead")], ["Booked", count("booked")], ["Completed", count("completed")], ["Going cold", cold.length]];
  return (
    <div className="max-w-5xl space-y-8" data-testid="pro-home">
      <PodcastRequestCard />
      <div>
        <p className="font-script text-[var(--gold)] text-3xl">Welcome back</p>
        <h1 className="font-serif font-light text-4xl">{user?.name || "Your business"}</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {stats.map(([l, v]) => <div key={l} className="bg-white border border-[var(--line)] rounded-2xl p-5" data-testid={`pro-stat-${l.toLowerCase().replace(/ /g, "-")}`}><p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">{l}</p><p className="font-serif text-4xl mt-1">{v}</p></div>)}
      </div>
      {cold.length > 0 && (
        <Link to="/dashboard/contacts" className="flex items-center gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 lift" data-testid="pro-cold-leads">
          <BellRing className="w-5 h-5 text-amber-600" />
          <span className="flex-1 text-sm"><b>{cold.length} {cold.length === 1 ? "lead hasn't" : "leads haven't"} heard from you in a week.</b> Follow up before they go cold.</span>
          <span className="text-xs text-[var(--gold)]">Open</span>
        </Link>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        {LINKS.map((x) => <Link key={x.to} to={x.to} className="lift bg-white border border-[var(--line)] rounded-2xl p-5 flex gap-4" data-testid={`pro-link-${x.to.split("/").pop()}`}><x.icon className="w-6 h-6 text-[var(--gold)] shrink-0" /><span><span className="font-serif text-xl block">{x.l}</span><span className="text-xs text-[var(--muted)]">{x.d}</span></span></Link>)}
      </div>
    </div>
  );
}
